import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import it from "./locales/it.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
    },
    fallbackLng: "it",
    lng: typeof window !== "undefined" && window.localStorage.getItem("sr_lang") ? undefined : "it",
    supportedLngs: ["it", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "sr_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
